import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initNative } from './lib/nativeInit'
import { isNativePlatform, waitForCapacitorBridge, markPlatformReady } from './lib/platform'

// Cold-boot sequence, in order:
//   1. Give the Capacitor bridge a brief window to inject window.Capacitor.
//      Prevents the class of bug where main.tsx runs before the bridge is
//      ready, wrongly takes the web branch on native, and every subsequent
//      storage write goes to WebView storage (wiped on force-close).
//   2. On native, await initNative() (primes Remember Me keys from
//      Preferences → localStorage, logs telemetry).
//   3. Flip platformReady so the Supabase storage adapter — which awaits
//      it on every call — knows the native-vs-web decision is final.
//   4. Mount React. AuthContext's first getSession() call will now hit
//      Preferences on native, guaranteed.
const bootstrap = async () => {
  await waitForCapacitorBridge(400);
  const native = isNativePlatform();
  if (native) {
    try { await initNative(); } catch (e) { console.warn('[main] initNative failed:', e); }
  } else {
    void initNative();
  }
  markPlatformReady();
  createRoot(document.getElementById("root")!).render(<App />);
};

void bootstrap();
